<template>
  <div class="list" @click="goDetail(item)">
    <div class="img-con">
      <img class="img" v-if="item.coverImage" :src="'http://img13.360buyimg.com/n1/' + item.coverImage" alt="">
      <img class="img" v-else-if="item.filePath" :src="'http://img13.360buyimg.com/n1/' + item.filePath[0]" alt="">
    </div>
    <div class="text-con">
      <div class="top-con">
        <div class="list-title">{{ item.goodsTitle }}</div>
        <div class="sub-text">
          <span class="num">热销:{{ item.products[0].collectUserCount }}</span>
          <span class="num">收藏:{{ item.products[0].salesVolume }}</span>
        </div>
      </div>
      <div class="middle-con">
        <span class="icon" :class="deductIcon" v-if="deductNum>10">{{ deductNum }} 枚</span>
      </div>
      <div class="price-con">
        <span class="price">{{ item.products[0].sellPrice===0?'免费':('￥'+item.products[0].sellPrice) }}</span>
        <s class="old-price" v-if="item.products[0].originalPrice">原价:￥{{ item.products[0].originalPrice }}</s>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex';
export default {
  props: {
    item: {
      required: true,
    }
  },
  computed:{
    ...mapGetters([
      'Pcoin',//平台金币信息
    ]),
    deductNum(){//金币抵扣数
      let num = (this.item.products[0].integralDeductCashAmount||0) / (this.Pcoin.buyPrice||1)
      return Math.floor(num)
    },
    deductIcon(){
      return ('icon'+(this.deductNum+'').length)
    },
  },

  methods: {
    // 跳转至商品详情
    goDetail(item) {
      // console.log(item)
      let query = {goodsId: item.goodsId, shopId: this.$route.query.shopId || item.shopId};
      if(this.$route.query.inviteUserId){
        query.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'jdGoodsDetail', query })
    },
  }
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.list{
  /*height: 102px;*/
  padding: 12px;
  display: flex;

  background-color: #fff;
  .img-con{
    width: 130px;
    height: 130px;
    position: relative;
    .img{
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  .text-con{
    justify-content: space-between;
    border-bottom: 1px solid #edecec;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-left: 10px;
    .top-con{
      .list-title{
        margin-bottom: 2px;
        padding-bottom: 2px;
        font-size: 14px;
        color: #2b2b2b;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
      }
      .sub-text{
        font-size: 9px;
        color: #999;
        .num{
          padding-right: 10px;
        }
        .price{
          font-size: 14px;
          color: #f34b4b;
          float: right;
        }
      }
    }
    .middle-con{
      flex: 1;height: 100%;display: inline-flex;align-items: center;
      .icon{
        height: 13px;line-height: 1;font-size: 9px;
        padding-top: 1px;padding-right: 3px;color: #ff8f2c;
        display: inline-flex;align-items: center;justify-content: flex-end;
      }
      .icon1{
        width: 36px;
        background: url("@{url}FnFxsvRodfrGoVx_1jZxBCngcpou") no-repeat 50% 50%;
        background-size: 100%;
      }
      .icon2{
        width: 41px;
        background: url("@{url}FkMAXPaeTv8q8huTMXwOzrRCJIfG") no-repeat 50% 50%;
        background-size: 100%;
      }
      .icon3{
        width: 46px;
        background: url("@{url}Frv6kqJMlpqlYXPNWDE09fsUW84K") no-repeat 50% 50%;
        background-size: 100%;
      }
      .icon4{
        width: 51px;
        background: url("@{url}FghdLLwybeDJ8A-OW5WgGyA4O6p5") no-repeat 50% 50%;
        background-size: 100%;
      }
    }
    .price-con{
      .price{font-size: 14px;color: #f74d4d;padding-right: 10px;}
      .old-price{font-size: 10px;color: #999;}
    }
  }
}
</style>